var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background white" },
    [
      _c(
        "v-row",
        { staticClass: "px-16 pt-6", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("img", {
                        staticClass: "arrow px-4 py-3",
                        attrs: { src: _vm.ic_back, id: "back-btn" },
                        on: { click: _vm.backTo },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ml-n4", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "back-lbl" }, [
                        _vm._v("Back to Pro Number Blocks "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "px-16 mb-16 mt-n10", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { staticClass: "mx-4 mt-5", attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "page-header" }, [
                      _vm._v(_vm._s(_vm.pageHeader)),
                    ]),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "pl-0 mt-n5", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "page-sub-header" }, [
                        _vm._v(
                          "Establish the block of PRO numbers for future shipments."
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "pro-section-lbl" }, [
                      _vm._v("Select the client"),
                    ]),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "pl-0 mt-n2", attrs: { cols: "4" } },
                    [
                      _c("smart-combobox", {
                        attrs: {
                          items: _vm.clientsList,
                          label: "Client Name",
                          readonly: true,
                          value: _vm.client.company,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "pro-section-lbl" }, [
                      _vm._v("Select the carrier"),
                    ]),
                    _c("label", { staticClass: "red-color" }, [_vm._v("*")]),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "pl-0 mt-n2", attrs: { cols: "4" } },
                    [
                      _c("smart-combobox", {
                        attrs: {
                          items: _vm.carriersList,
                          label: "Carrier Name",
                        },
                        on: { change: _vm.onCarrierSelect },
                        model: {
                          value: _vm.selectedCarrier,
                          callback: function ($$v) {
                            _vm.selectedCarrier = $$v
                          },
                          expression: "selectedCarrier",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "12" } },
                    [
                      _c("v-switch", {
                        staticClass: "show-spot-contracts",
                        attrs: {
                          label: "Show Spot Contracts",
                          color: "success",
                          "hide-details": "",
                          disabled: !_vm.selectedCarrier,
                          ripple: false,
                        },
                        model: {
                          value: _vm.showSpotContracts,
                          callback: function ($$v) {
                            _vm.showSpotContracts = $$v
                          },
                          expression: "showSpotContracts",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "pro-section-lbl" }, [
                      _vm._v(
                        "Select the carrier contracts that correspond with this client"
                      ),
                    ]),
                    _c("label", { staticClass: "red-color" }, [_vm._v("*")]),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "pl-0 mt-n2", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "br-8", attrs: { elevation: "1" } },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("v-data-table", {
                                key: _vm.tableKey,
                                attrs: {
                                  id: "users-grid",
                                  headers: _vm.contractsHeaders,
                                  items: _vm.page,
                                  "hide-default-footer": true,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.id",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c("v-checkbox", {
                                          ref: _vm.getRefName(item.contractId),
                                          staticClass: "mt-0 smart-checkbox",
                                          attrs: {
                                            ripple: false,
                                            "hide-details": true,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onContractSelect(item)
                                            },
                                          },
                                          model: {
                                            value: item.selected,
                                            callback: function ($$v) {
                                              _vm.$set(item, "selected", $$v)
                                            },
                                            expression: "item.selected",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.status",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "label",
                                          {
                                            class: {
                                              "active-account":
                                                _vm.isActiveContract(
                                                  item.contractExpDate,
                                                  item.status
                                                ),
                                              "inactive-account":
                                                !_vm.isActiveContract(
                                                  item.contractExpDate,
                                                  item.status
                                                ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.isActiveContract(
                                                  item.contractExpDate,
                                                  item.status
                                                )
                                                  ? "ACTIVE"
                                                  : "INACTIVE"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.contractId",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "label",
                                          { staticClass: "contract-link" },
                                          [_vm._v(_vm._s(item.contractId))]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.contractEffDate",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(
                                                item.contractEffDate
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.contractExpDate",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(
                                                item.contractExpDate
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.pagingLength > 1
                ? _c(
                    "v-row",
                    { staticClass: "mt-6", attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "auto" } },
                        [
                          _c("v-pagination", {
                            staticClass: "pl-3",
                            attrs: {
                              length: _vm.pagingLength,
                              "total-visible": "10",
                            },
                            on: { input: _vm.pageChange },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("postal-codes-input", {
                ref: "postalCodesInput",
                model: {
                  value: _vm.zipCodes,
                  callback: function ($$v) {
                    _vm.zipCodes = $$v
                  },
                  expression: "zipCodes",
                },
              }),
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { staticClass: "pl-0", attrs: { cols: "12" } },
                            [
                              _c("label", { staticClass: "pro-section-lbl" }, [
                                _vm._v(
                                  "Determine the carrier's Pro number length"
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-0 mt-n2", attrs: { cols: "8" } },
                            [
                              _c("smart-text-field", {
                                attrs: {
                                  placeholder: "Enter Digit Count",
                                  number: true,
                                  required: true,
                                  maxlength: 2,
                                  clearable: true,
                                },
                                model: {
                                  value: _vm.digitCount,
                                  callback: function ($$v) {
                                    _vm.digitCount = $$v
                                  },
                                  expression: "digitCount",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-0 mt-4", attrs: { cols: "12" } },
                            [
                              _c("label", { staticClass: "pro-section-lbl" }, [
                                _vm._v("Enter the Pro number formula"),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-0 mt-n2", attrs: { cols: "8" } },
                            [
                              _c("smart-text-field", {
                                attrs: {
                                  placeholder: "Pro Prefix",
                                  clearable: true,
                                  maxlength: 4,
                                },
                                model: {
                                  value: _vm.prefix,
                                  callback: function ($$v) {
                                    _vm.prefix = $$v
                                  },
                                  expression: "prefix",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-0", attrs: { cols: "8" } },
                            [
                              _c("smart-text-field", {
                                attrs: {
                                  placeholder: "Pro Suffix",
                                  clearable: true,
                                  maxlength: 4,
                                },
                                model: {
                                  value: _vm.suffix,
                                  callback: function ($$v) {
                                    _vm.suffix = $$v
                                  },
                                  expression: "suffix",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-0", attrs: { cols: "8" } },
                            [
                              _c("smart-text-field", {
                                attrs: {
                                  placeholder: "Check Format",
                                  clearable: true,
                                  maxlength: 10,
                                },
                                model: {
                                  value: _vm.format,
                                  callback: function ($$v) {
                                    _vm.format = $$v
                                  },
                                  expression: "format",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-0 mt-4", attrs: { cols: "12" } },
                            [
                              _c("label", { staticClass: "pro-section-lbl" }, [
                                _vm._v("Set your Range"),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pl-0 mt-n6",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "pro-section-explainer" },
                                [
                                  _vm._v(
                                    "This will show the amount of pro numbers available for this carrier"
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-0", attrs: { cols: "8" } },
                            [
                              _c("smart-text-field", {
                                attrs: {
                                  placeholder: "Pro Number Starting Range",
                                  clearable: true,
                                  number: true,
                                  required: true,
                                  maxlength: _vm.digitCount,
                                },
                                model: {
                                  value: _vm.startingRange,
                                  callback: function ($$v) {
                                    _vm.startingRange = $$v
                                  },
                                  expression: "startingRange",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-0", attrs: { cols: "8" } },
                            [
                              _c("smart-text-field", {
                                attrs: {
                                  placeholder: "Pro Number Ending Range",
                                  clearable: true,
                                  number: true,
                                  required: true,
                                  maxlength: _vm.digitCount,
                                },
                                model: {
                                  value: _vm.endingRange,
                                  callback: function ($$v) {
                                    _vm.endingRange = $$v
                                  },
                                  expression: "endingRange",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-0 mt-4", attrs: { cols: "12" } },
                            [
                              _c("label", { staticClass: "pro-section-lbl" }, [
                                _vm._v("Priority Level "),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pl-0 mt-n6",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "pro-section-explainer" },
                                [
                                  _vm._v(
                                    "This will indicate the batch order for future shipments"
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-0", attrs: { cols: "8" } },
                            [
                              _c("smart-combobox", {
                                attrs: {
                                  items: _vm.priorityList,
                                  label: "Pro Range Priority",
                                  required: true,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "auto" } },
                                              [
                                                item.text == "Use 1st"
                                                  ? _c("img", {
                                                      attrs: {
                                                        src: _vm.ic_use_1st,
                                                      },
                                                    })
                                                  : _vm._e(),
                                                item.text == "Use 2nd"
                                                  ? _c("img", {
                                                      attrs: {
                                                        src: _vm.ic_use_2nd,
                                                      },
                                                    })
                                                  : _vm._e(),
                                                item.text != "Use 2nd" &&
                                                item.text != "Use 1st"
                                                  ? _c("img", {
                                                      staticClass: "use-3rd",
                                                      attrs: {
                                                        src: _vm.ic_use_3rd,
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "auto" } },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(item.text) + " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "selection",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "v-row",
                                          { staticClass: "hover" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "auto" } },
                                              [
                                                _c("img", {
                                                  staticClass: "hover",
                                                  attrs: {
                                                    src: _vm.getSelectedImage(
                                                      item
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "auto" } },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "hover" },
                                                  [_vm._v(_vm._s(item.text))]
                                                ),
                                              ]
                                            ),
                                            _c("v-spacer"),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.priority,
                                  callback: function ($$v) {
                                    _vm.priority = $$v
                                  },
                                  expression: "priority",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { staticClass: "pl-0", attrs: { cols: "12" } },
                            [
                              _c("label", { staticClass: "pro-section-lbl" }, [
                                _vm._v("Stats"),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pl-0 mt-n2",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("label", { staticClass: "pro-stat" }, [
                                _vm._v(
                                  "Total Amount of Pro Numbers to Assign "
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pl-0 mt-n4",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("label", { staticClass: "pro-stat" }, [
                                _vm._v(_vm._s(_vm.totalPros) + " "),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pl-0 mt-n4",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("label", { staticClass: "pro-stat" }, [
                                _vm._v("Pro Numbers Used "),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pl-0 mt-n4",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("label", { staticClass: "pro-stat" }, [
                                _vm._v(_vm._s(_vm.totalUsedPros)),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pl-0 mt-n4",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("label", { staticClass: "pro-stat" }, [
                                _vm._v("Pro Numbers Remaining"),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pl-0 mt-n4",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "label",
                                {
                                  class: {
                                    "green-color": _vm.remaining > 50,
                                    "red-color": _vm.remaining <= 50,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.remaining))]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mt-10" },
            [
              _c("v-spacer"),
              _c(
                "v-col",
                { attrs: { cols: "auto" } },
                [
                  _c("smart-btn", {
                    attrs: {
                      label: "Cancel",
                      bg: "white",
                      border: "navy-blue",
                      font: "navy-blue",
                    },
                    on: { click: _vm.backTo },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "auto" } },
                [
                  _c("smart-btn", {
                    class: { "w-100-pct": _vm.smAndDown },
                    attrs: { label: "Save", type: "primary" },
                    on: { click: _vm.showConfirm },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v(_vm._s(_vm.loadingMessage)),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px" },
          model: {
            value: _vm.displayPopup,
            callback: function ($$v) {
              _vm.displayPopup = $$v
            },
            expression: "displayPopup",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "br-10" },
            [
              _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "py-10 px-10 ta-c",
                      attrs: { row: "", wrap: "" },
                    },
                    [
                      !_vm.formValid
                        ? _c("v-flex", [
                            _c("label", { staticClass: "are-you-sure-lbl" }, [
                              _vm._v("Errors found"),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.formValid && !_vm.isEdit && !_vm.isCopy
                        ? _c("v-flex", [
                            _c("label", { staticClass: "are-you-sure-lbl" }, [
                              _vm._v("Link together?"),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.formValid && _vm.isEdit
                        ? _c("v-flex", [
                            _c("label", { staticClass: "are-you-sure-lbl" }, [
                              _vm._v("Confirm the change"),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.formValid && _vm.isCopy
                        ? _c("v-flex", [
                            _c("label", { staticClass: "are-you-sure-lbl" }, [
                              _vm._v("Copy pro block"),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.emptyFields
                        ? _c("v-flex", { staticClass: "mt-6 ta-c" }, [
                            _c("label", { staticClass: "text-lbl" }, [
                              _vm._v(" The following fields "),
                              _c("b", [_vm._v("cannot be empty")]),
                              _vm._v(": " + _vm._s(_vm.emptyFields)),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.proRangeInvalid
                        ? _c("v-flex", { staticClass: "mt-6 ta-c" }, [
                            _c("label", { staticClass: "text-lbl" }, [
                              _vm._v(" The Pro Number "),
                              _c("b", [_vm._v("Ending Range")]),
                              _vm._v(
                                " must have a value greater than the Pro Number "
                              ),
                              _c("b", [_vm._v("Starting Range")]),
                              _vm._v(
                                " to define a valid range. Please ensure that the value entered for the Pro Number Ending Range is greater than the Pro Number Starting Range."
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.contractsNotSelected
                        ? _c("v-flex", { staticClass: "mt-6 ta-c" }, [
                            _c("label", { staticClass: "text-lbl" }, [
                              _vm._v(" Please select "),
                              _c("b", [_vm._v("at least one")]),
                              _vm._v(
                                " carrier contract that corresponds with this client."
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.hasPostalCodeValidationErrors
                        ? _c("v-flex", { staticClass: "mt-6 ta-c" }, [
                            _c("label", { staticClass: "text-lbl" }, [
                              _vm._v(" Please correct the "),
                              _c("b", [_vm._v("invalid postal codes")]),
                              _vm._v(
                                ". Use US format (12345 or 12345-6789) or Canadian format (A1A 1A1)."
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.formValid && !_vm.isEdit && !_vm.isCopy
                        ? _c("v-flex", { staticClass: "mt-6 ta-c" }, [
                            _c("label", { staticClass: "text-lbl" }, [
                              _vm._v(
                                " If you have a different batch of pro numbers with a different priority level that shares the same carrier contracts, these pro blocks will link together. Would you like to continue?"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.formValid && _vm.isEdit
                        ? _c("v-flex", { staticClass: "mt-6 ta-c" }, [
                            _c("label", { staticClass: "text-lbl" }, [
                              _vm._v(
                                " Updating the existing Pro Numbers block could potentially impact how we assign Pro numbers for future shipments. We want to make sure that you are aware of this potential effect before proceeding with the change."
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.formValid && _vm.isCopy
                        ? _c("v-flex", { staticClass: "mt-6 ta-c" }, [
                            _c("label", { staticClass: "text-lbl" }, [
                              _vm._v(
                                " Copying this existing Pro Numbers block could potentially impact how we assign Pro numbers for future shipments. We want to make sure that you are aware of this potential effect before proceeding with the change."
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c(
                        "v-row",
                        { staticClass: "ta-c w-100-pct" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "mt-8", attrs: { cols: "12" } },
                            [
                              _vm.formValid
                                ? _c("smart-btn", {
                                    staticClass: "mr-4",
                                    attrs: { type: "dismiss", label: "Cancel" },
                                    on: {
                                      click: function ($event) {
                                        _vm.displayPopup = false
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm.formValid
                                ? _c("smart-btn", {
                                    staticClass: "m0auto",
                                    attrs: {
                                      type: "primary",
                                      label: "OK",
                                      loading: _vm.saving,
                                    },
                                    on: { click: _vm.submitForm },
                                  })
                                : _vm._e(),
                              !_vm.formValid
                                ? _c("smart-btn", {
                                    staticClass: "m0auto",
                                    attrs: { type: "primary", label: "OK" },
                                    on: {
                                      click: function ($event) {
                                        _vm.displayPopup = false
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-snackbar",
                {
                  staticClass: "smart-snackbar",
                  scopedSlots: _vm._u([
                    {
                      key: "action",
                      fn: function (ref) {
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._b(
                              {
                                attrs: { color: "#007BFF", text: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.snackbar = false
                                  },
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            [_vm._v(" Close ")]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.snackbar,
                    callback: function ($$v) {
                      _vm.snackbar = $$v
                    },
                    expression: "snackbar",
                  },
                },
                [
                  _c("img", {
                    staticClass: "success-icon",
                    attrs: { src: _vm.ic_green_success_checkmark },
                  }),
                  _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }